import { lemonSqueezySetup } from '@lemonsqueezy/lemonsqueezy.js';

/**
 * Lemon Squeezy Configuration
 *
 * Initializes the Lemon Squeezy SDK with the API token from environment variables.
 * This should be called once at application startup.
 */

const LEMON_SQUEEZY_API_TOKEN = process.env.REACT_APP_LEMON_SQUEEZY_TOKEN;

if (!LEMON_SQUEEZY_API_TOKEN) {
  console.warn('REACT_APP_LEMON_SQUEEZY_TOKEN is not set. Lemon Squeezy features will not work.');
}

/**
 * Initialize Lemon Squeezy SDK
 * Must be called before making any API requests
 */
export const initializeLemonSqueezy = () => {
  if (!LEMON_SQUEEZY_API_TOKEN) {
    throw new Error('Lemon Squeezy API token is not configured');
  }

  lemonSqueezySetup({
    apiKey: LEMON_SQUEEZY_API_TOKEN,
    onError: (error) => {
      console.error('Lemon Squeezy API Error:', error);
    },
  });
};

// Initialize on module load
if (LEMON_SQUEEZY_API_TOKEN) {
  initializeLemonSqueezy();
}

export default initializeLemonSqueezy;
